import React, { ChangeEvent, Component } from 'react';
import { TrackerCookieVariable } from '../../../../domain/tracker/variable/TrackerVariable';
import FormicaLabel from '../../../custom/FormicaLabel';
import FormicaInput from '../../../custom/FormicaInput';
import RoleHelper from '../../../../RoleHelper';
import FormicaToggleSwitch from '../../../custom/FormicaToggleSwitch';

class TrackerCookieVariableComponent extends Component<Props> {
  public render() {
    const { variable } = this.props;
    return (
      <div>
        <div className={'border-b py-5'}>
          <div className={'flex flex-col gap-y-1'}>
            <FormicaLabel label={'Cookie Name'} />
            <FormicaInput value={variable.cookieName} onChange={this.onChangeCookieName} disabled={!RoleHelper.canEdit('Tracker')} />
          </div>
        </div>
        <div className={'border-b py-5'}>
          <div className={'flex flex-col gap-y-1'}>
            <FormicaLabel label={'Decode URL Cookie'} />
            <FormicaToggleSwitch value={variable.decodeUrlCookie} onChange={this.onChangeDecodeUri} disabled={!RoleHelper.canEdit('Tracker')} />
          </div>
        </div>
      </div>
    );
  }

  private onChangeCookieName = (e: ChangeEvent<HTMLInputElement>) => {
    const { variable, onChange } = this.props;
    variable.cookieName = e.currentTarget.value;
    onChange(variable);
  };

  private onChangeDecodeUri = (e: any) => {
    const { variable, onChange } = this.props;
    variable.decodeUrlCookie = !variable.decodeUrlCookie;
    onChange(variable);
  };
}

interface Props {
  variable: TrackerCookieVariable;
  onChange: (variable: TrackerCookieVariable) => void;
}

export default TrackerCookieVariableComponent;
